export const noSpinnerSx = {
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": { display: "none" },
  "& input[type=number]": { MozAppearance: "textfield" },
} as const;

export const sx = { noSpinnerSx };
